import React, { useEffect, useState } from 'react';
import CreatePackaging from './CreatePackaging';
// import PackingList from './PackagingList';
import PackagingList from './PackagingList';
import { toast } from "../../../components/AppToast";
import { savePackingDataAPI } from '../../../services/packing/packing';
import { getPackingListAPI } from '../../../services/packing/packing';
import { updatePkgMgtAPI } from '../../../services/packing/packing';

export default function PkgManagement() {
    const [packing, setPackingdata] = useState()
    const [isCreating, setIsCreating] = useState(false);
    const [activeRecord, setActiveRecord] = useState(null); // view/edit
 const [listVersion, setListVersion] = useState();

    const onlyFormVisible = isCreating || !!activeRecord;

    const closeForm = () => {
        setIsCreating(false);
        setActiveRecord(null);
    };

 

    const submitForm = async (formData, id) => {
        try {
            if (id) {
               
            
                const updateDate = await updatePkgMgtAPI(formData,id);
                if (updateDate.success===true) {
                     toast.success("Packing updated successfully");
                    closeForm();
                    setListVersion(v=>v+1);
                }
                else {
                    toast.error('Packing updation failed')
                }
            }
            else {

                const getesult = await savePackingDataAPI(formData);
             

                if (getesult.success === true) {
                    toast.success("Packing created successfully");
                    closeForm();
                    setListVersion(v=>v+1);
                }
                else {
                    toast.error('packing creation failed')
                }
            }

        }
        catch (err) {
            throw err;
        }
    }

    return (


        <div className="card shadow-lg main-card">

            {/* ---------- HEADER ---------- */}
            <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
                <h4 className="mb-0 h6 fw-semibold">
                    {!onlyFormVisible
                        ? "Packaging Management"
                        : isCreating
                            ? "Create Packaging Mgt "
                            : activeRecord?.mode === "edit"
                                ? "Edit Packaging Mgt"
                                : "View Packaging Mgt"}
                </h4>
            </div>


            {/* ---------- BREADCRUMBS ---------- */}
            {onlyFormVisible && (
                <nav
                    aria-label="breadcrumb"
                    className="px-3 py-2 border-bottom bg-light"
                >
                    <ol
                        className="breadcrumb mb-0 align-items-center"
                        style={{ ["--bs-breadcrumb-divider"]: "'/'" }}
                    >
                        <li className="breadcrumb-item">
                            <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none text-muted"
                                onClick={closeForm}
                            >
                                Packaging Management
                            </button>
                        </li>

                        <li
                            className="breadcrumb-item active fw-semibold text-primary"
                            aria-current="page"
                        >
                            {isCreating
                                ? "Create Packaging Mgt"
                                : activeRecord?.mode === "edit"
                                    ? "Edit Packaging Mgt"
                                    : "View Packaging Mgt"}
                        </li>
                    </ol>
                </nav>
            )}



            <div className="card-body">
                {!onlyFormVisible ? (
                    <PackagingList
                        refreshKey={listVersion}
                        onCreateClick={() => setIsCreating(true)}
                        onView={(row) =>
                            setActiveRecord({ mode: "view", data: row })
                        }
                        onEdit={(row) =>
                            setActiveRecord({ mode: "edit", data: row })
                        }
                    />
                ) : (


                    <CreatePackaging
                        initialValues={activeRecord?.data || {}}
                        onCancel={closeForm}
                        onSubmit={submitForm}
                        viewOnly={activeRecord?.mode === "view"}
                        isEdit={activeRecord?.mode === "edit"}
                    />


                )}
            </div>



        </div>
    );
};


